import apiClient from '../apiClient';
import { UPLOAD_COMMIT_RESTAURANT_PROFILE_URL } from '../apiUrl';

const uploadMasterRestaurantProfileApi = data => {
  return apiClient.post(UPLOAD_COMMIT_RESTAURANT_PROFILE_URL, data);
};

export default uploadMasterRestaurantProfileApi;
